<template>
  <div
    v-for="(section, sectionIndex) in sections"
    :id="section.slug"
    :key="section.slug || sectionIndex"
    :class="section.classes"
    class="section"
  >
    <div
      v-for="(content, contentIndex) in section.content"
      :key="contentIndex"
      class="block"
    >
      <component
        :is="component(content)"
        v-bind="content.props"
        :id="content.slug"
      >
        <template v-for="(slot, key) in slotContent(content)" #[key] :key="key">
          <component
            :is="component(element)"
            v-bind="element.props"
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            :class="element.class"
          >
            {{ element.text }}
          </component>
        </template>
      </component>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "HeadlessLayout",
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    component(content) {
      if (content.tag) {
        return content.tag;
      }

      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot;
    },
  },
};
</script>

<style lang="scss" scoped>
.single {
  margin: 0 0 2px 0;
}

.grid {
  display: grid;
  gap: 2px;

  @include respond-above(md) {
    &--1col {
      grid-template-columns: 1fr;
    }

    &--2col {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
